/* Sad Boy Saga — free-shoe pre-checkout popup (deal CHOOSER).
 *
 * Second popup before checkout (Forever Hungry fh-cart-modal pattern). The customer
 * PICKS which deal to take — the popup does not auto-switch by quantity:
 *   Buy 1, Get 1 Free  -> 1 free pair  (needs 1 paid shoe)   [needs BOGO discount live]
 *   Buy 2, Get 3 Free  -> 3 free pairs (needs 2 paid shoes)  [live "Bts" discount]
 *
 * Shopify applies the single best AUTOMATIC discount for whatever ends up in the cart,
 * so the chooser sets the customer's INTENT (how many free pairs to add) while the
 * "You saved" line always shows Shopify's REAL computed discount from /cart.js.
 *
 * Interop with sbs-app.js:
 *   window.sbsRenderCart(cart)  -> re-render the cart drawer after our add
 *   'sbs:cart:updated' event    -> fires on every drawer render so we re-sync
 */
(function () {
  'use strict';
  var modal = document.querySelector('[data-fs-modal]');
  var overlay = document.querySelector('[data-fs-overlay]');
  if (!modal) return;

  var idsEl = document.querySelector('[data-sbs-shoe-ids]');
  var SHOE_IDS = new Set();
  try { (JSON.parse(idsEl.textContent) || []).forEach(function (id) { SHOE_IDS.add(Number(id)); }); } catch (e) {}
  var BOGO_ON = modal.getAttribute('data-bogo-enabled') === 'true';

  var DEALS = {
    bogo: { key: 'bogo', name: 'Buy 1, Get 1 Free', buy: +modal.getAttribute('data-buy-qty-bogo') || 1, slots: +modal.getAttribute('data-slots-bogo') || 1, enabled: BOGO_ON },
    b2g3: { key: 'b2g3', name: 'Buy 2, Get 3 Free', buy: +modal.getAttribute('data-buy-qty-b2g3') || 2, slots: +modal.getAttribute('data-slots-b2g3') || 3, enabled: true }
  };
  var state = { deal: BOGO_ON ? 'bogo' : 'b2g3' };
  var lastCart = null;

  function $(s, r) { return (r || modal).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || modal).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function money(cents) { var n = (Number(cents) || 0) / 100; return '$' + (n % 1 === 0 ? n.toFixed(0) : n.toFixed(2)); }
  function withWidth(url, w) { if (!url) return ''; try { var u = new URL(url, window.location.origin); u.searchParams.set('width', w); return u.toString(); } catch (e) { return url; } }

  function shoeCount(cart) { var n = 0; (cart && cart.items || []).forEach(function (it) { if (SHOE_IDS.has(Number(it.product_id))) n += it.quantity; }); return n; }
  function inCartPids(cart) { var s = new Set(); (cart && cart.items || []).forEach(function (it) { if (SHOE_IDS.has(Number(it.product_id))) s.add(Number(it.product_id)); }); return s; }
  function filledFor(deal, count) { return Math.max(0, Math.min(count - deal.buy, deal.slots)); }
  function anyRemaining(count) {
    return Object.keys(DEALS).some(function (k) { var d = DEALS[k]; return d.enabled && (d.slots - filledFor(d, count)) > 0; });
  }
  function getCart() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); }); }

  function activeDeal() {
    var d = DEALS[state.deal];
    if (!d || !d.enabled) { state.deal = 'b2g3'; d = DEALS.b2g3; }
    return d;
  }

  function render(cart) {
    lastCart = cart;
    var count = shoeCount(cart);
    renderNudge(count);
    if (count < 1) { if (modal.classList.contains('is-open')) closeModal(); return; }

    // deal chooser buttons (hide BOGO if not enabled)
    $$('[data-fs-deal]').forEach(function (btn) {
      var key = btn.getAttribute('data-fs-deal');
      var d = DEALS[key];
      btn.hidden = !d || !d.enabled;
      var on = key === state.deal;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    // if only one deal is available, the chooser has nothing to choose — hide it
    var enabledCount = Object.keys(DEALS).filter(function (k) { return DEALS[k].enabled; }).length;
    var deals = $('[data-fs-deals]'); if (deals) deals.hidden = enabledCount < 2;

    var deal = activeDeal();
    var filled = filledFor(deal, count);
    var remaining = deal.slots - filled;
    var needPaid = Math.max(0, deal.buy - count);
    modal.classList.toggle('fs-modal--maxed', remaining <= 0);

    var eyebrow = $('[data-fs-eyebrow]'), title = $('[data-fs-title]'), sub = $('[data-fs-sub]');
    eyebrow.textContent = enabledCount >= 2 ? 'Pick your deal' : deal.name;
    if (deal.key === 'bogo') {
      if (needPaid > 0) { title.textContent = 'Add a pair to start.'; sub.textContent = 'Buy 1, get 1 free — add a pair and the second is on us.'; }
      else if (filled === 0) { title.textContent = 'Add a 2nd pair — it’s free.'; sub.textContent = 'Buy 1, get 1 free. Your lower-priced pair comes off automatically at checkout.'; }
      else { title.textContent = 'Free pair — claimed.'; sub.textContent = 'Want 3 free instead? Switch to Buy 2, Get 3 Free above.'; }
    } else {
      if (needPaid > 0) { title.textContent = 'Add ' + needPaid + ' more paid pair' + (needPaid === 1 ? '' : 's') + ' to unlock.'; sub.textContent = 'Buy 2, get 3 free — then pick 3 pairs on us.'; }
      else if (filled === 0) { title.textContent = 'Pick your 3 free pairs.'; sub.textContent = 'You bought 2. The next three are on us — lowest-priced pairs come off at checkout.'; }
      else if (remaining > 0) { title.textContent = remaining + ' more free ' + (remaining === 1 ? 'pair' : 'pairs') + ' to grab.'; sub.textContent = 'Keep stacking — you’re not paying for these.'; }
      else { title.textContent = 'All 3 free pairs — claimed.'; sub.textContent = 'Max reached. They come off automatically at checkout.'; }
    }

    // pips for the selected deal
    var prog = $('[data-fs-prog]'), pipHtml = '';
    for (var i = 0; i < deal.slots; i++) pipHtml += '<span class="fs-pip' + (i < filled ? ' on' : '') + '"></span>';
    prog.innerHTML = pipHtml + '<span class="fs-count"><b>' + filled + '</b>/' + deal.slots + ' Free</span>';

    // snapshot + savings (real)
    $('[data-fs-thumbs]').innerHTML = (cart.items || []).slice(0, 6).map(function (it) { return '<img src="' + esc(withWidth(it.image, 80)) + '" alt="" loading="lazy">'; }).join('');
    $('[data-fs-count]').textContent = cart.item_count + ' item' + (cart.item_count === 1 ? '' : 's');
    $('[data-fs-snapsub]').textContent = money(cart.total_price);
    var saved = cart.total_discount || 0, saverow = $('[data-fs-saverow]');
    if (saved > 0) { saverow.hidden = false; $('[data-fs-saveval]').textContent = '-' + money(saved); } else saverow.hidden = true;
    $('[data-fs-subtotal]').textContent = money(cart.total_price);

    // cards: hide shoes already in cart; lock when the chosen deal is maxed
    var have = inCartPids(cart);
    $$('[data-fs-card]').forEach(function (card) {
      card.hidden = have.has(Number(card.getAttribute('data-pid')));
      card.classList.toggle('fs-card--locked', remaining <= 0);
      var sizes = card.querySelector('[data-fs-sizes]'); if (sizes) sizes.hidden = true;
      var addBtn = card.querySelector('[data-fs-add]'); if (addBtn) addBtn.hidden = false;
    });
  }

  function renderNudge(count) {
    var nudge = document.querySelector('[data-freeshoe-nudge]');
    if (!nudge) return;
    if (count < 1 || !anyRemaining(count)) { nudge.hidden = true; return; }
    nudge.hidden = false;
    var best = DEALS.b2g3.enabled && count >= DEALS.b2g3.buy ? DEALS.b2g3 : (DEALS.bogo.enabled ? DEALS.bogo : DEALS.b2g3);
    var rem = best.slots - filledFor(best, count);
    nudge.innerHTML = '<span class="fs-nudge__txt"><b>' + rem + ' free pair' + (rem === 1 ? '' : 's') + '</b> waiting — pick them at checkout</span>';
  }

  var lastFocus = null;
  function openModal() {
    lastFocus = document.activeElement;
    if (overlay) { overlay.hidden = false; requestAnimationFrame(function () { overlay.classList.add('is-open'); }); }
    modal.hidden = false; requestAnimationFrame(function () { modal.classList.add('is-open'); });
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
    var c = $('[data-fs-close]'); if (c) setTimeout(function () { c.focus(); }, 40);
  }
  function closeModal() {
    modal.classList.remove('is-open'); if (overlay) overlay.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true'); document.body.classList.remove('no-scroll');
    setTimeout(function () { modal.hidden = true; if (overlay) overlay.hidden = true; }, 220);
    $$('[data-fs-sizes]').forEach(function (s) { s.hidden = true; });
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function cartAdd(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    }).then(function (r) { if (!r.ok) return r.json().then(function (b) { throw new Error(b.description || 'Add failed'); }); return r.json(); });
  }
  function afterAdd() {
    return getCart().then(function (cart) {
      if (typeof window.sbsRenderCart === 'function') window.sbsRenderCart(cart); else render(cart);
    });
  }
  function openSizes(card) {
    var box = card.querySelector('[data-fs-sizes]'), addBtn = card.querySelector('[data-fs-add]');
    if (!box) return;
    var variants = [];
    try { variants = JSON.parse(card.querySelector('[data-fs-variants]').textContent) || []; } catch (e) {}
    var seen = {}, html = '';
    variants.forEach(function (v) {
      var sz = v.s == null ? '' : String(v.s); if (sz === '' || seen[sz]) return; seen[sz] = true;
      html += '<button type="button" class="fs-size' + (v.a ? '' : ' oos') + '" data-vid="' + v.id + '"' + (v.a ? '' : ' disabled') + '>' + esc(sz) + '</button>';
    });
    box.innerHTML = html; box.hidden = false; if (addBtn) addBtn.hidden = true;
  }

  modal.addEventListener('click', function (e) {
    var dealBtn = e.target.closest('[data-fs-deal]');
    if (dealBtn) { var k = dealBtn.getAttribute('data-fs-deal'); if (DEALS[k] && DEALS[k].enabled) { state.deal = k; if (lastCart) render(lastCart); } return; }
    var closeBtn = e.target.closest('[data-fs-close], [data-fs-skip]');
    if (closeBtn) { e.preventDefault(); if (closeBtn.hasAttribute('data-fs-skip')) window.location.href = '/checkout'; else closeModal(); return; }
    var addBtn = e.target.closest('[data-fs-add]');
    if (addBtn) { openSizes(addBtn.closest('[data-fs-card]')); return; }
    var size = e.target.closest('.fs-size');
    if (size && !size.disabled) {
      var vid = size.getAttribute('data-vid'); if (!vid) return;
      size.classList.add('is-loading');
      cartAdd(vid).then(afterAdd).catch(function (err) { if (typeof window.sbsToast === 'function') window.sbsToast(err.message || 'Add to cart failed'); size.classList.remove('is-loading'); });
      return;
    }
  });
  if (overlay) overlay.addEventListener('click', closeModal);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal(); });

  // checkout intercept — capture phase, runs before sbs-app's stale-cart guard.
  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-checkout-link]');
    if (!link || modal.contains(link)) return;
    var count = shoeCount(lastCart || {});
    if (count >= 1 && anyRemaining(count)) { e.preventDefault(); e.stopImmediatePropagation(); openModal(); }
  }, true);

  document.addEventListener('sbs:cart:updated', function (e) { if (e.detail) render(e.detail); });
  getCart().then(render).catch(function () {});
})();
